<template>
    <b-modal :ref="modalRef" hide-footer :title="modalTitle" :id="modalId" :size="modalSize">
        <div class="d-flex align-items-center flex-column">
            <i class="ic-alert-circle" style="width: 48px; height: auto;"></i>
            <span class="modal-content-text text-center mt-2">
                <slot name="subtitle">Etes-vous sûr de vouloir supprimer cet élément ?</slot>
                <br />
                <slot name="subtitle2"></slot>
            </span>
        </div>

        <div class="row justify-content-end mt-4">
            <button type="button" class="btn btn-secondary-light-o btn-radius" @click="$bvModal.hide(modalId)">
                <slot name="cancelButtonText">Non, annuler</slot>
            </button>
            <div class="col-auto">
                <button type="button" class="btn btn-primary btn-radius" @click="confirmDelete">
                    <slot name="confirmButtonText">Oui, supprimer</slot>
                </button>
            </div>
        </div>
    </b-modal>
</template>
  
<script>
export default {
    props: {
        modalRef: {
            type: String,
            default: 'deleteConfirmModalRef',
        },
        modalId: {
            type: String,
            default: 'delete-confirm-modal',
        },
        modalTitle: {
            type: String,
            default: 'Confirmation',
        },
        modalSize: {
            type: String,
            default: 'md',
        },
    },
    methods: {
        confirmDelete() {
            this.$emit('confirm');
            this.$bvModal.hide(this.modalId);
        },
    },
};
</script>
  